export default function IconLayerRenderer({ layer }) {
  const data = layer.data;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: data.color,
        fontSize: data.fontSize,
        lineHeight: 1,
      }}
    >
      <i className={data.iconClass} />
    </div>
  );
}
